export default function(next, options, selectedOption) {
  if (selectedOption) {
    const index = options.indexOf(selectedOption);
    const sibling = next ? options[index + 1] : options[index - 1];
    const def = next ? options[0] : options[options.length - 1];
    return sibling || def;
  }
  return options[0];
}
